import * as APIHelper from "services/api"
import * as endPoint from "shared/constants/endpoint"

class GeneralBusiness {
  getCompanyList = async () => {
    let result = []
    const options = { params: { activeonly: "Y" } }
    const response = (await APIHelper.getRequest(`${endPoint.company.list}`, options)) || {}
    if (response && Array.isArray(response.resource)) {
      result = response.resource.map(x => {
        return {
          company: x.COMPANY,
          name: x.NAME,
        }
      })
    }
    return result
  }

  getCarrierService = async () => {
    const response = (await APIHelper.getRequest(`${endPoint.carrierService}`)) || []

    // The API returns a bare array of carrier/service rows; tolerate a
    // { resource: [...] } envelope too in case the response is ever wrapped.
    return Array.isArray(response) ? response : response?.resource || []
  }

  getFilterCriteria = async () => {
    const options = { params: { filter_name: "", v: new Date().getTime() } }
    const response = (await APIHelper.getRequest(`${endPoint.filterCriteria.list}`, options)) || []

    return response
  }

  getProductList = async () => {
    const response = (await APIHelper.getRequest(`${endPoint.product.list}`)) || {}

    return response?.resource || []
  }

  getUserPermissions = async email => {
    const options = { params: { UserName: email, ResourceID: 1 } }
    return (await APIHelper.getRequest(`${endPoint.user.getUserPermissions}`, options)) || []
  }

  getEnvironmentVariables = async () => {
    return (await APIHelper.getRequest(`${endPoint.environmentVariables}`)) || []
  }

  getUserConfigs = async (email, company) => {
    const options = { params: { User_Email: email, Company_Code: company } }
    return (await APIHelper.getRequest(`${endPoint.user.getUserConfigs}`, options)) || []
  }

  getCompanyWarehouses = async company => {
    const options = { params: { COMPANY: company } }
    return ((await APIHelper.getRequest(`${endPoint.companyWarehouses}`, options)) || []).map(x => x.WAREHOUSE)
  }

  addUserConfig = async (data, userName, company, email) => {
    data.Company_Code = company
    data.Created_By = userName
    data.User_Email = email

    const response = await APIHelper.postRequest(`${endPoint.user.addUserConfig}`, data)
    return response
  }

  updateUserConfig = async (id, data, userName) => {
    data.Modified_By = userName
    data.Id = id
    const response = await APIHelper.patchRequest(`${endPoint.user.updateUserConfig}`, data)
    return response
  }

  deleteUserConfig = async id => {
    const options = { Id: id }
    return (await APIHelper.deleteRequest(`${endPoint.user.deleteUserConfig}`, options)) || []
  }

  getNotifications = async () => {
    const response = (await APIHelper.getRequest(`${endPoint.notification}`)) || []
    const now = new Date()
    return response.filter(x => {
      return x.Active && x.Start_Date && new Date(x.Start_Date) <= now && (!x.End_Date || new Date(x.End_Date) >= now)
    })
  }

  sendEmail = async payload => {
    const response = await APIHelper.postRequest(`${endPoint.sendEmail}`, payload)
    return response
  }
}

export const generalBusiness = new GeneralBusiness()
